import { ChessboardStatus, type ChessboardDto } from '@/core/data/chessboard/chessboard.interface';

// One act per 20 hours per board, so eligibility depends only on when this
// user last acted here — not on who moved last or at which spot.
export function isEligibleForMove(board: ChessboardDto, userId?: string): boolean {
  if (!userId) return false;
  if (board.status !== ChessboardStatus.ACTIVE) return false;
  if (board.pendingActionByUserId === userId) return false;
  if (!board.nextMoveAt) return true;

  return new Date(board.nextMoveAt).getTime() <= Date.now();
}

export function isWaitingForMove(board: ChessboardDto, userId?: string): boolean {
  if (!userId) return false;
  if (board.status !== ChessboardStatus.ACTIVE) return false;
  if (!board.participantUserIds?.includes(userId)) return false;
  return !isEligibleForMove(board, userId);
}

export function hasPlayedBoard(board: ChessboardDto, userId?: string): boolean {
  if (!userId) return false;
  return board.participantUserIds?.includes(userId) ?? false;
}

export function hasPlantedBoard(board: ChessboardDto, userId?: string): boolean {
  if (!userId) return false;
  return board.plantedByUserId === userId;
}

function relevanceScore(board: ChessboardDto, userId?: string): number {
  if (isEligibleForMove(board, userId)) return 3;
  if (hasPlayedBoard(board, userId)) return 2;
  if (hasPlantedBoard(board, userId)) return 1;
  return 0;
}

export function sortSpotBoards(boards: ChessboardDto[], userId?: string): ChessboardDto[] {
  return [...boards].sort((a, b) => {
    const scoreA = relevanceScore(a, userId);
    const scoreB = relevanceScore(b, userId);
    if (scoreA !== scoreB) return scoreB - scoreA;

    const timeA = a.lastMoveAt ? new Date(a.lastMoveAt).getTime() : 0;
    const timeB = b.lastMoveAt ? new Date(b.lastMoveAt).getTime() : 0;
    return timeB - timeA;
  });
}
